import { GeneralMessageEmailForm } from './GeneralMessageEmailForm';
export default GeneralMessageEmailForm;
